import richTextRendererUtils from "@/utils/richTextRenderer";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Document } from "@contentful/rich-text-types";
import { Stack, Typography } from "@mui/material";

import { SecurityScamSectionLeftImage } from "./SecurityScamSectionLeftImage";
import { SecurityScamSectionRightImage } from "./SecurityScamSectionRightImage/SecurityScamSectionRightImage";
import { SecurityScamSectionCardProps } from "./types";
import { styles } from "./styles";

export const SecurityScamSectionCard: React.FC<SecurityScamSectionCardProps> = ({
  descriptionWithRichText,
  description,
  title,
  left,
  right,
  hideLeftTopLine
}) => {
  return (
    <Stack direction={{ md: "row", xs: left?.image ? "column" : "column-reverse" }} justifyContent="space-between">
      {left ? (
        <SecurityScamSectionLeftImage
          src={left.image}
          topBulletColor={left.topBulletColor}
          bottomBulletColor={left.bottomBulletColor}
          hideLeftTopLine={hideLeftTopLine}
        />
      ) : null}

      <Stack
        pr={{ xs: "24px", md: left?.image ? "84px" : "24px" }}
        pl={{ xs: "24px", md: left?.image ? "24px" : "84px" }}
        zIndex={2}
        mb={left?.image || right?.image ? { md: "70px", xs: "16px" } : { md: "0px", xs: "0px" }}
        mt={
          left?.image || right?.image
            ? {
                md: "64px",
                xs: "36px"
              }
            : { md: "36px", xs: "36px" }
        }
      >
        <Typography fontSize={24} fontWeight={600} lineHeight="29.05px" bgcolor="white">
          {title}
        </Typography>

        <Typography
          fontSize={16}
          fontWeight={400}
          lineHeight="22.4px"
          color="#58595B"
          marginTop="16px"
          bgcolor="white"
          marginBottom="16px"
          css={styles.typography__description}
          component="section"
          sx={{
            whiteSpace: "break-word"
          }}
        >
          {descriptionWithRichText ? documentToReactComponents(descriptionWithRichText as Document, richTextRendererUtils) : description}
        </Typography>
      </Stack>

      {right ? (
        <SecurityScamSectionRightImage src={right.image} topBulletColor={right.topBulletColor} bottomBulletColor={right.bottomBulletColor} />
      ) : null}
    </Stack>
  );
};
